import { ROUTES } from '../../lib/routes';
import { el } from '../../utils/dom';
import { openAnalyticsSettings } from '../../analytics';

function contactLine(label: string, href: string, linkText: string): HTMLElement {
  const p = el('p', { className: 'ev123-footer__contact-line' });
  p.append(
    document.createTextNode(`${label} `),
    el('a', {
      className: 'ev123-footer__contact-link',
      href,
      text: linkText,
    })
  );
  return p;
}

export function createSiteFooter(): HTMLElement {
  const footer = el('footer', { className: 'ev123-footer' });
  const inner = el('div', { className: 'ev123-container ev123-footer__grid' });

  const contactBlock = el('div', { className: 'ev123-footer__contact-block' });
  contactBlock.append(
    contactLine('대표번호', 'tel:1544-3610', '1544-3610'),
    contactLine('직통번호', 'tel:010-8409-3610', '010-8409-3610'),
    (() => {
      const p = el('p', { className: 'ev123-footer__contact-line' });
      p.append(
        document.createTextNode('이메일 '),
        el('a', {
          className: 'ev123-footer__contact-link',
          href: 'mailto:linkcs@evcinfo.kr',
          text: 'linkcs@evcinfo.kr',
        })
      );
      return p;
    })()
  );

  const colBrand = el('div', { className: 'ev123-footer__col-brand' });
  colBrand.append(
    el('p', { className: 'ev123-footer__org-title', text: 'EV종합지원센터' }),
    el('p', { className: 'ev123-footer__company', text: '(주)한국EV링크넷' }),
    el('div', { className: 'ev123-footer__portal-note' }, [
      el('div', { className: 'ev123-footer__brand', text: 'EV123' }),
      el('p', {
        className: 'ev123-card__desc ev123-footer__tagline',
        text: '전기차충전기 설치 판단 포털',
      }),
    ])
  );

  const navLinks = el('nav', { className: 'ev123-footer__nav-links', 'aria-label': '푸터 메뉴' });
  const linkSpecs: [string, string][] = [
    [ROUTES.newInstall, '충전기 설치'],
    [ROUTES.consult, '설치 상담'],
    [ROUTES.installCaseBoard, '설치사례'],
    [ROUTES.resources, '자료실'],
    [ROUTES.differentiatedServices, '차별화서비스'],
    [ROUTES.serviceApply, '서비스 신청'],
  ];
  for (const [href, text] of linkSpecs) {
    navLinks.appendChild(
      el('a', {
        href,
        'data-nav': '',
        text,
      }) as HTMLAnchorElement
    );
  }

  const bottomRow = el('div', { className: 'ev123-footer__bottom-row' });
  const analyticsSettings = el('button', {
    type: 'button',
    className: 'ev123-footer__analytics-settings',
    text: '분석 설정 변경',
  });
  analyticsSettings.addEventListener('click', openAnalyticsSettings);
  bottomRow.append(
    el('span', { className: 'ev123-footer__copy', text: '© EV123' }),
    analyticsSettings,
    el('a', {
      className: 'ev123-footer__expo',
      href: '/monitor_01_loop.html',
      text: '행사·홍보',
      title: '행사·홍보 모니터 페이지',
    })
  );

  const colMeta = el('div', { className: 'ev123-footer__col-meta' });
  colMeta.append(contactBlock, navLinks, bottomRow);

  inner.append(colBrand, colMeta);
  footer.appendChild(inner);
  return footer;
}
